import { render } from "./Settings.vue?vue&type=template&id=4d286a9c&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4d286a9c"

export default script